import React from 'react';
import { Redirect } from 'react-router-dom';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import LoginForm from '../../containers/login-form';
import AppRoute from '../../enums/routes';
import useToken from '../../hooks/useToken';

const Login: React.FC = () => {
  const { isAuthenticated } = useToken();
  const isAuth = isAuthenticated();

  if (isAuth) {
    return <Redirect to={AppRoute.Dashboard} />;
  }

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.REACT_APP_RECAPTCHA_V3_SITE_KEY || ''}
    >
      <div className="h-screen bg-rp-grey flex items-center justify-center">
        <LoginForm />
      </div>
    </GoogleReCaptchaProvider>
  );
};

export default Login;
